module.exports = __webpack_public_path__ + "static/media/allenberg.f598cce1.jpg";